import { Outlet } from 'react-router-dom';
import { UpdaterModal } from '../widgets/UpdaterModal';

export const Content = () => {
  return (
    <>
      <UpdaterModal />
      <Outlet />
    </>
  );
};
